// In-house standalone feature flag that steers the OpsPilot acknowledgement UX
// (consent dialog + acknowledged notice + action item). Read directly via
// `useFlagsQuery` (like `useIsOpsPilotEnabled`) — intentionally NOT wired into
// ABILITY_CONFIG, since it gates UI state only, never feature access.
export const OPSPILOT_ACK_FLAG = 'ui__standalone--opspilot-acknowledgement';

// PostHog audit event emitted when a user acknowledges the disclaimer.
export const OPSPILOT_ACK_EVENT_TITLE = 'OpsPilot Disclaimer Acknowledged';
export const OPSPILOT_ACK_EVENT_TYPE = 'consent';

// PostHog events emitted whenever OpsPilot is actually enabled / disabled.
export const OPSPILOT_ENABLED_EVENT_TITLE = 'OpsPilot Enabled';
export const OPSPILOT_DISABLED_EVENT_TITLE = 'OpsPilot Disabled';
export const OPSPILOT_TOGGLE_EVENT_TYPE = 'feature_toggle';

// Bump when the legal-approved disclaimer copy / terms change.
export const OPSPILOT_TERMS_VERSION = 'v1';

export const OPSPILOT_TERMS_URL = 'https://cast.ai/terms-of-service/';
export const OPSPILOT_PRIVACY_URL = 'https://cast.ai/privacy-policy/';

// PostHog property keys (organization group + person level) used for audit.
export const OPSPILOT_PROP = {
  enabled: 'opspilot_enabled',
  acknowledgedAt: 'opspilot_acknowledged_at',
  acknowledgedBy: 'opspilot_acknowledged_by',
  termsVersion: 'opspilot_terms_version',
  userLastAcknowledgedAt: 'opspilot_last_acknowledged_at',
  userLastAcknowledgedOrg: 'opspilot_last_acknowledged_org',
} as const;
